import { openWhatsApp } from "../../lib/whatsapp";

const WhatsAppIcon = ({ size = 26 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    width={size}
    height={size}
    fill="currentColor"
    aria-hidden="true"
  >
    <path d="M19.11 17.205c-.372 0-1.088 1.39-1.518 1.39a.63.63 0 0 1-.315-.1c-.802-.402-1.504-.817-2.163-1.447-.545-.516-1.146-1.29-1.46-1.963a.426.426 0 0 1-.073-.215c0-.33.99-.945.99-1.49 0-.143-.73-2.09-.832-2.335-.143-.372-.214-.487-.6-.487-.187 0-.36-.043-.53-.043-.302 0-.53.115-.746.315-.688.645-1.032 1.318-1.06 2.264v.114c-.015.99.472 1.977 1.017 2.78 1.23 1.82 2.506 3.41 4.554 4.34.616.287 2.035.916 2.722.916.215 0 .487-.014.703-.057.748-.13 1.633-.673 1.834-1.404.014-.07.014-.144.014-.214 0-.27-.014-.314-.143-.514-.214-.36-1.103-.787-1.49-.787zM16 5.21c5.96 0 10.79 4.83 10.79 10.79 0 1.762-.43 3.512-1.252 5.077l-1.06 2.04 2.187-.585 2.087-.56-.56 2.046-.587 2.146 2.06-.99c1.47-.703 3.01-1.59 4.55-1.59C26.79 4.66 17.83 0 11.86 0 5.49 0 .14 5.18.14 11.55c0 1.85.45 3.66 1.32 5.27L0 21.71l5.05-1.32A11.488 11.488 0 0 0 16 26.79zm0 25.18c-2.69 0-5.32-.722-7.62-2.09l-.547-.323-5.66 1.477 1.508-5.51-.36-.572C2.05 21.59 1.4 18.835 1.4 16 1.4 7.953 7.953 1.4 16 1.4 24.046 1.4 30.6 7.953 30.6 16c0 8.046-6.553 14.6-14.6 14.6z" />
  </svg>
);

export const FloatingWhatsApp = () => {
  return (
    <button
      data-testid="floating-whatsapp-btn"
      onClick={() =>
        openWhatsApp("Hola Aitor, vengo de tu web. Quiero el CAMBIO.")
      }
      className="fixed bottom-24 right-6 sm:bottom-6 sm:left-6 sm:right-auto z-50 bg-[#25D366] hover:bg-[#20bd5a] text-white p-4 rounded-full shadow-2xl transition-transform hover:scale-110 flex items-center justify-center group"
      aria-label="Contactar por WhatsApp"
    >
      <span className="absolute inline-flex h-full w-full rounded-full bg-[#25D366] opacity-60 animate-ping group-hover:opacity-0" />
      <span className="relative flex">
        <WhatsAppIcon size={26} />
      </span>
    </button>
  );
};
